import icon1 from '../../assets/images/icon-snappy-process.svg'
import icon2 from '../../assets/images/icon-affordable-prices.svg'
import icon3 from '../../assets/images/icon-people-first.svg'

const reasons=[
    {
        title: 'snappy process', 
        icon: icon1, 
        reason:'Our application process can be completed in minutes, not hours. Dont get stuck filling in tedious forms.'
    },
    {
        title:'affordable Prices',
        icon:icon2,
        reason:"we don't want you worrying about high monthly cost. Our prices may be low, but we still offer the best coverage possible."
    },
    {
        title:'people firts',
        icon:icon3,
        reason:"Our plans aren't full of conditions and clauses to prevent payouts. We make sure you're covered when you need it"
    }
]

export default reasons